export enum StaffType {
    CIVILSERVANT, 
    CONTRACT,
    CIVIL_LABOR
}
